<template>
  <div>
    <v-app-bar
      app
      color="amber lighten-3"
      clipped-left
      :clipped-right="isRightNavDrawerVisible"
      dense
      justify-center
      v-bind="{ ...$attrs, ...$props }"
    >
      <v-app-bar-nav-icon
        v-if="$mq === 'xs' || $mq === 'sm'"
        @click="isDrawerVisible = true"
      />
      <v-btn class="home-btn mr-1" to="/" text small tile>
        {{ getShopTitle }}
      </v-btn>
      <v-spacer />

      <AdminAccountBtnDropdown />
    </v-app-bar>
    <AdminNavDrawer
      :show="isDrawerVisible"
      @toggle="isDrawerVisible = $event"
    />
    <AdminSupportNavDrawer v-if="isViewingSupportPage" />
    <AdminShopSettingsNavDrawer v-if="isViewingSettingsPage" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AdminNavDrawer from '@/components/AdminNavDrawer'
import AdminSupportNavDrawer from '@/components/AdminSupportNavDrawer'
import AdminShopSettingsNavDrawer from '@/components/AdminShopSettingsNavDrawer'
import AdminAccountBtnDropdown from '@/components/AdminAccountBtnDropdown'
import RouteNames from '@/constants/RouteNames'

export default {
  name: 'NavBar',
  components: {
    AdminAccountBtnDropdown,
    AdminNavDrawer,
    AdminSupportNavDrawer,
    AdminShopSettingsNavDrawer,
  },
  data() {
    return {
      isDrawerVisible: false,
      CustomerDashRoute: RouteNames.Customer.ORDERS_INDEX,
    }
  },
  computed: {
    ...mapGetters('shop', ['getShopTitle']),
    isViewingSupportPage() {
      return this.$route.name === RouteNames.Merchant.Manage.SUPPORT
    }, // isViewingSupportPage
    isViewingSettingsPage() {
      return this.$route.name === RouteNames.Merchant.Manage.SHOP_SETTINGS
    }, // isViewingSettingsPage
    isRightNavDrawerVisible() {
      return this.isViewingSupportPage || this.isViewingSettingsPage
    }, // isRightNavDrawerVisible
  },
}
</script>

<style lang="scss">
.home-btn.v-btn {
  justify-content: start;
  min-width: 10px;
  max-width: calc(100% - 80px);
  overflow: hidden;
  .v-btn__content {
    width: 100%;
    white-space: initial;
    // text-overflow: ellipsis;
  }
}
.v-btn.home-btn:before {
  background: transparent;
}
.v-btn.home-btn {
  :hover:before {
    background: #ffb300;
    opacity: 0.3;
  }
  &.bar-btn:hover:before {
    background: #00fcff;
    opacity: 0.4;
  }
}
</style>
